import React, { createContext, useContext, useState } from "react";
const Context = createContext([]);
export function LayoutProvider({ children, headerId, footerId }) {
    const [layout, setLayout] = useState({
        footerId: footerId || null,
        headerId: headerId || null,
    });
    function updateLayout(layoutPart) {
        const l = Object.assign(Object.assign({}, layout), layoutPart);
        setLayout(l);
    }
    return (React.createElement(Context.Provider, { value: [layout, updateLayout] }, children));
}
export function useLayoutContext() {
    return useContext(Context);
}
